import { useEffect, useState } from "react";
import {
  Badge,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import DeleteOutlineSharpIcon from '@mui/icons-material/DeleteOutlineSharp';
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import { onHubEvent, startRealtimeHub } from "../../Services/realtimeHubService";
import NotificationsNoneSharpIcon from '@mui/icons-material/NotificationsNoneSharp';
import WorkOutlineSharpIcon from '@mui/icons-material/WorkOutlineSharp';
import ChatBubbleOutlineSharpIcon from '@mui/icons-material/ChatBubbleOutlineSharp';
import FavoriteBorderSharpIcon from '@mui/icons-material/FavoriteBorderSharp';
import NotificationsToast from "../NotificationsToast";
import axios from "../../API/axios";
import { getUnreadNotificationCount } from "../../Services/apiService";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { transform } from "lodash";
import { ListRowSkeleton } from "@skeleton";
import { post } from "../../config/imagesLink";
import { useTranslation } from "react-i18next";
import { TOP_NOTIFICATION_SOUND_URL } from "../../config/staticAssets";

export default function TopNotification({
  closeTooltip,
  notifiCount: notifiCountProp,
  setNotifiCount: setNotifiCountProp,
}) {
  const sessionId = localStorage.getItem("sessionId");
  const { t } = useTranslation();

  const [notifi, setNotifi] = useState([]);
  const [notifiCount, setNotifiCount] = useState(() => {
    const stored = localStorage.getItem("NotificationCountData");
    return stored != null && stored !== "" ? Number(stored) : 0;
  });

  const displayCount =
    notifiCountProp !== undefined && notifiCountProp !== null && notifiCountProp !== ""
      ? Number(notifiCountProp) || 0
      : Number(notifiCount) || 0;

  const applyCount = (count) => {
    if (count == null) return;
    setNotifiCount(count);
    setNotifiCountProp?.(count);
  };
  const [notificationData, setNoticationData] = useState({});
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(true);


  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const language = localStorage.getItem("Lang");



  const NotificationList = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
            langKey: language === "en" ? "" : language,

    };
    try {
      // setLoading(true);
      await axios
        .post(`General/GetTop5Notifications`, data)
        
        .then((resData) => {
          console.log("resDataNew", resData);
          setNotifi(resData.data.responseData);
          setIsLoading(false);
          setIsError(false);

        });
    } catch (error) {
      // console.log("error", error);
      if (error.response.status === 404 || error.status === 404) {
        setIsLoading(false);
        
        setIsError(true);
      } else {
        console.log("error", error.response.status);
      }

      // setLoading(false);
    }
  };
  const ReadNotification = async (id) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
            langKey: language === "en" ? "" : language,

    };
    try {
      await axios
        .post(`General/MarkNotificationAsRead?ID=${id}`, responseData)
        .then((res) => {
          NotificationList();
        });
    } catch (e) {
      console.log(e.response);
    }
  };
  const navigate = useNavigate();
  const [unauthorisedModal, setUnauthorisedModal] = useState(false);

  const NotificationCount = async ({ forceRefresh = false } = {}) => {
    try {
      const count = await getUnreadNotificationCount({ forceRefresh });
      if (count != null) {
        applyCount(count);
      }
    } catch (error) {
      // handle session expiry (401) gracefully: clear fetched flag and notify app
      if (error && error.response && error.response.status === 401) {
        try {
          localStorage.removeItem("NotificationCountFetched");
        } catch (e) {
          // ignore storage errors
        }
        // let the rest of the app handle session expiry (existing global handler)
        window.dispatchEvent(new Event("sessionExpired"));
      } else {
        // other errors are ignored here (preserve previous behavior)
        // if ((error.code === 'ERR_NETWORK' && sessionId) || (error.code === "ERR_BAD_REQUEST" && sessionId)) {
        //   setUnauthorisedModal(true)
        // }
      }
    }
  };

  useEffect(() => {
    if (!sessionId) return undefined;

    NotificationCount({ forceRefresh: true });

    const handleUserLoggedIn = () => {
      NotificationCount({ forceRefresh: true });
    };

    const handleCountUpdated = (event) => {
      const count = event?.detail?.count;
      if (count != null) {
        applyCount(count);
      }
    };

    window.addEventListener("userLoggedIn", handleUserLoggedIn);
    window.addEventListener("notificationCountUpdated", handleCountUpdated);

    return () => {
      window.removeEventListener("userLoggedIn", handleUserLoggedIn);
      window.removeEventListener("notificationCountUpdated", handleCountUpdated);
    };
  }, [sessionId]);

  useEffect(() => {
    let cancelled = false;
    let unsubscribeNotification;

    const setupHub = async () => {
      try {
        await startRealtimeHub();
      } catch (e) {
        console.log("Connection failed: ", e);
        return;
      }

      if (cancelled) return;

      unsubscribeNotification = onHubEvent("RealTimeNotification", (notification) => {
        NotificationCount({ forceRefresh: true });

        const loggedInUserId = localStorage.getItem("CheckNotifyId");

        if (
          Array.isArray(notification.toUsers_Ids) &&
          notification.toUsers_Ids.includes(loggedInUserId) &&
          notification.fromUserId !== loggedInUserId
        ) {
          setTimeout(() => {
            const audio = new Audio(TOP_NOTIFICATION_SOUND_URL);
            audio.play().catch((err) => console.log("Audio play failed:", err));
            setShow(true);
            setNoticationData(notification);
          }, 3000);
        } else {
          console.log("Ignored self-notification");
        }
      });
    };

    setupHub();

    return () => {
      cancelled = true;
      unsubscribeNotification?.();
    };
  }, []);

  //************************Delete Post start  ************************//

  const [showDropdown, setShowDropdown] = useState(false);
  const [deleteId, setDeleteId] = useState(null);


  const [showD, setShowD] = useState(false);
  const handleDeleteClose = () => {
    setShowD(false);
  };

  const deleteNoti = async (event) => {
    event.preventDefault();
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
            langKey: language === "en" ? "" : language,

    };
    try {
      await axios
        .post(`General/DeleteNotification?ID=${deleteId}`, responseData)

        .then((res) => {
          // toast.success(res.data.message);
          setToastMessage(res.data.message);
          setShowToast(true);
          NotificationList();
          NotificationCount({ forceRefresh: true });
          setShowD(!showD);
          // setNotificationList((prev) => prev.filter((item) => item.ntfctnId !== deleteId));
          // NotificationCount()
        });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  // useEffect(() => {
  //   if (show) {
  //     document.body.style.overflow = 'hidden';
  //     document.documentElement.style.overflow = 'hidden';
  //     document.body.classList.add('modal-open'); // When a modal opens
  //   } else {
  //     document.body.style.overflow = 'unset';
  //     document.documentElement.style.overflow = '';
  //     document.body.classList.remove('modal-open'); // When a modal closes
  //   }
  // }, [show]);

  //************************Delete Post End  ************************//


  const renderNotificationItems = () => {
    return (
      
      <div className="notificationscroller">
        {notifi &&
          notifi?.map((item, index) => {
            const now = moment();
            const itemTime = moment.utc(item?.time);
            const duration = moment.duration(now.diff(itemTime));

            const years = duration.years();
            const months = duration.months();
            const days = duration.days();
            const hours = duration.hours();
            const minutes = duration.minutes();

            let result = "";
 
             if (years > 0) {
                  result = `${years} ${t("Notifications.Year")}${years > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                } else if (months > 0) {
                  result = `${months} ${t("Notifications.Month")}${months > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                } else if (days > 0) {
                  result = `${days} ${t("Notifications.Day")}${days > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                } else if (hours > 0) {
                  result = `${hours} ${t("Notifications.Hour")}${hours > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                } else if (minutes > 0) {
                  result = `${minutes} ${t("Notifications.Minute")}${minutes > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                } else {
                  result = t("Notifications.Just Now");
                }
            return item?.isView === false ? (
              item?.type === 3 ||
                item?.type === 12 ||
                item?.type === 13 ||
                item?.type === 14 ||
                item?.type === 15 ||
                item?.type === 16 ? (
                // <li
                //   className="dropdown-menu-header unreadNotification"
                //   key={index}
                // >
                //   {
                //     <DropdownItem
                //       to={`/User/${item?.fromUserUid}`}
                //       onClick={(e) => {
                //         ReadNotification(item?.ntfctnId);
                //       }}
                //       tag={Link}
                //       className="topnotification d-flex align-items-center"
                //     >
                //       <img
                //         src={item?.fromProfilPic}
                //         width={30}
                //         height={30}
                //         style={{ borderRadius: "50px" }}
                //         className="me-3"
                //         alt="Profile Icon"
                //       />
                //       <div className="me-3">
                //         <h2 className="notification-message mb-0">
                //           <span>{item?.fromUserFname}</span>
                //         </h2>
                //         <h6 className="mb-0 content-text">
                //           <span>{item?.content}</span>
                //         </h6>
                //         <span className="side-text ms-0">{result}</span>
                //       </div>
                //       {item?.typeName === "JobPost" ? (
                //         <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                //           <WorkOutlineSharpIcon className="material-symbols-outlined" />
                //         </div>
                //       ) : item?.typeName === "Message" ? (
                //         <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                //           <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                //         </div>
                //       ) : item?.typeName === "Like" ? (
                //         <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                //           <FavoriteBorderSharpIcon className="material-symbols-outlined" />

                //         </div>
                //       ) : (
                //         ""
                //       )}
                //       <DeleteOutlineSharpIcon className="material-symbols-sharp me-2 pointer delete-iconsymbols"

                //         style={{ color: 'red !important' }}
                //         onClick={(e) => {
                //           e.preventDefault();
                //           e.stopPropagation();
                //           setDeleteId(item?.ntfctnId);  // Save ID
                //           setShowD(true);                // Open modal
                //           toggleDropdown();
                //         }} />
                //     </DropdownItem>
                //   }
                // </li>
                <li className="dropdown-menu-header unreadNotification notificationList" key={index}>
                  <DropdownItem
                    to={`/User/${item?.fromUserUid}`}
                    onClick={(e) => {
                      ReadNotification(item?.ntfctnId);
                    }}
                    tag={Link}
                    className="topnotification d-flex align-items-center"
                  >
                    {/* Profile Pic */}
                    <img
                      src={item?.fromProfilPic}
                      width={40}
                      height={40}
                      style={{ borderRadius: "50%" }}
                      className="me-3"
                      alt="Profile Icon"
                    />

                    {/* Text Container */}
                    <div className="notification-text flex-grow-1">
                      {/* Top row → User + Time */}
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="notification-message mb-0">
                          <span>{item?.fromUserFname}</span>
                        </div>
                        <span className="side-text ms-0">{result}</span>
                      </div>

                
                      <div className="d-flex align-items-center justify-content-between">
                        {/* Left → Content */}
                        <div className="mb-0 content-text me-2">
                          <span>{item?.content}</span>
                        </div>

                        {/* Right → Icons + Delete */}
                        <div className="d-flex align-items-center">
                          {item?.typeName === "JobPost" && (
                            <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                              <WorkOutlineSharpIcon className="material-symbols-outlined" />
                            </div>
                          )}
                          {item?.typeName === "Message" && (
                            <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                              <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                            </div>
                          )}
                          {item?.typeName === "Like" && (
                            <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                              <FavoriteBorderSharpIcon className="material-symbols-outlined" />

                            </div>
                          )}
                          <div className="ms-auto d-flex justify-content-center align-items-center me-2">
                            <DeleteOutlineSharpIcon
                              className="material-symbols-sharp pointer delete-iconsymbols"
                              style={{ color: "red" }}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setDeleteId(item?.ntfctnId);
                                setShowD(true);
                                toggleDropdown();
                              }}
                            />

                          </div>

                        </div>
                      </div>

                    </div>
                  </DropdownItem>
                </li>

              ) : item?.type === 1 ? (
                <li
                  className="dropdown-menu-header unreadNotification"
                  key={index}
                >
                  {
                    <DropdownItem
                      onClick={() => {
                        ReadNotification(item?.ntfctnId);
                      }}
                      to={`/Company/${item?.fromUserUid}`}
                      tag={Link}
                      className="topnotification d-flex align-items-center"
                    >
                      <img
                        src={item?.fromProfilPic}
                        width={30}
                        height={30}
                        style={{ borderRadius: "50px" }}
                        className="me-3"
                        alt="Profile Icon"
                      />
                      <div className="me-3">
                        <h2 className="notification-message mb-0">
                          <span>{item?.fromUserFname}</span>
                        </h2>
                        <h6 className="mb-0 content-text">
                          <span>{item?.content}</span>
                        </h6>
                        <span className="side-text ms-0">{result}</span>
                      </div>
                      {item?.typeName === "JobPost" ? (
                        <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">

                          <WorkOutlineSharpIcon className="material-symbols-outlined" />
                        </div>
                      ) : item?.typeName === "Message" ? (
                        <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                          <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                        </div>
                      ) : item?.typeName === "Like" ? (
                        <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2 heart-icon">
                          <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                        </div>
                      ) : (
                        ""
                      )}
                      <DeleteOutlineSharpIcon className="material-symbols-sharp me-2 pointer delete-iconsymbols"

                        style={{ color: 'red !important' }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setDeleteId(item?.ntfctnId);  // Save ID
                          setShowD(true);                // Open modal
                          toggleDropdown();
                        }} />
                    </DropdownItem>
                  }
                </li>
              ) : item?.type === 2 ? (
                // <li
                //   className="dropdown-menu-header unreadNotification"
                //   key={index}
                // >
                //   {
                //     <DropdownItem
                //       onClick={(e) => {
                //         ReadNotification(item?.ntfctnId);
                //       }}
                //       to={`/Message/${item.fromUserUid}`}
                //       tag={Link}
                //       className="topnotification d-flex align-items-center"
                //     >
                //       <img
                //         src={item?.fromProfilPic}
                //         width={30}
                //         height={30}
                //         style={{ borderRadius: "50px" }}
                //         className="me-3"
                //         alt="Profile Icon"
                //       />
                //       <div className="me-3">
                //         <h2 className="notification-message mb-0">
                //           <span>{item?.fromUserFname}</span>
                //         </h2>
                //         <h6 className="mb-0 content-text">
                //           <span>{item?.content}</span>
                //         </h6>
                //         <span className="side-text ms-0">{result}</span>
                //       </div>
                //       {item?.typeName === "JobPost" ? (
                //         <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">

                //           <WorkOutlineSharpIcon className="material-symbols-outlined" />
                //         </div>
                //       ) : item?.typeName === "Message" ? (
                //         <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                //           <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                //         </div>
                //       ) : item?.typeName === "Like" ? (
                //         <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2 heart-icon">
                //           <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                //         </div>
                //       ) : (
                //         ""
                //       )}
                //       <DeleteOutlineSharpIcon className="material-symbols-sharp me-2 pointer delete-iconsymbols"

                //         style={{ color: 'red !important' }}
                //         onClick={(e) => {
                //           e.preventDefault();
                //           e.stopPropagation();
                //           setDeleteId(item?.ntfctnId);  // Save ID
                //           setShowD(true);                // Open modal
                //           toggleDropdown();
                //         }} />
                //     </DropdownItem>
                //   }
                // </li>
                <li className="dropdown-menu-header unreadNotification" key={index}>
                  <DropdownItem
                    to={`/User/${item?.fromUserUid}`}
                    onClick={(e) => {
                      ReadNotification(item?.ntfctnId);
                    }}
                    tag={Link}
                    className="topnotification d-flex align-items-center"
                  >
                    {/* Profile Pic */}
                    <img
                      src={item?.fromProfilPic}
                      width={40}
                      height={40}
                      style={{ borderRadius: "50%" }}
                      className="me-3"
                      alt="Profile Icon"
                    />

                    {/* Text Container */}
                    <div className="notification-text flex-grow-1">
                      {/* Top row → User + Time */}
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="notification-message mb-0">
                          <span>{item?.fromUserFname}</span>
                        </div>
                        <span className="side-text ms-0">{result}</span>
                      </div>

                      {/* Bottom row → Content + Icons */}
                      {/* <div className="d-flex justify-content-between align-items-center">
                        <div className="mb-0 content-text"><span>{item?.content}</span></div>

                        <div className="d-flex align-items-center">
                          {item?.typeName === "JobPost" ? (
                            <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                              <WorkOutlineSharpIcon className="material-symbols-outlined" />
                            </div>
                          ) : item?.typeName === "Message" ? (
                            <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                              <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                            </div>
                          ) : item?.typeName === "Like" ? (
                            <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                              <FavoriteBorderSharpIcon className="material-symbols-outlined" />

                            </div>
                          ) : (
                            ""
                          )}

                          <DeleteOutlineSharpIcon
                            className="material-symbols-sharp pointer delete-iconsymbols"
                            style={{ color: "red" }}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setDeleteId(item?.ntfctnId);
                              setShowD(true);
                              toggleDropdown();
                            }}
                          />
                        </div>
                      </div> */}
                      <div className="d-flex align-items-center justify-content-between">
                        {/* Left → Content */}
                        <div className="mb-0 content-text me-2">
                          <span>{item?.content}</span>
                        </div>

                        {/* Right → Icons + Delete */}
                        <div className="d-flex align-items-center">
                          {item?.typeName === "JobPost" && (
                            <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                              <WorkOutlineSharpIcon className="material-symbols-outlined" />
                            </div>
                          )}
                          {item?.typeName === "Message" && (
                            <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                              <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                            </div>
                          )}
                          {item?.typeName === "Like" && (
                            <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                              <FavoriteBorderSharpIcon className="material-symbols-outlined" />

                            </div>
                          )}
                          <div className="ms-auto d-flex justify-content-center align-items-center me-2">
                            <DeleteOutlineSharpIcon
                              className="material-symbols-sharp pointer delete-iconsymbols"
                              style={{ color: "red" }}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setDeleteId(item?.ntfctnId);
                                setShowD(true);
                                toggleDropdown();
                              }}
                            />

                          </div>

                        </div>
                      </div>

                    </div>
                  </DropdownItem>
                </li>
              ) : item?.type === 4 ||
                item?.type === 5 ||
                item?.type === 6 ||
                item?.type === 7 ||
                item?.type === 8 ||
                item?.type === 9 ||
                item?.type === 10 ||
                item?.type === 11 ||
                item?.type === 24 ||
                item?.type === 18 ? (
                // <li
                //   className="dropdown-menu-header unreadNotification"
                //   key={index}
                // >
                //   {
                //     <DropdownItem
                //       onClick={() => {
                //         ReadNotification(item?.ntfctnId);
                //       }}
                //       to={`/Post/${item?.refLinkId}`}
                //       tag={Link}
                //       className="topnotification d-flex align-items-center"
                //     >
                //       <img
                //         src={item?.fromProfilPic}
                //         width={30}
                //         height={30}
                //         style={{ borderRadius: "50px" }}
                //         className="me-3"
                //         alt="Profile Icon"
                //       />
                //       <div className="me-3">
                //         <h2 className="notification-message mb-0">
                //           <span>{item?.fromUserFname}</span>
                //         </h2>
                //         <h6 className="mb-0 content-text">
                //           <span>{item?.content}</span>
                //         </h6>
                //         <span className="side-text ms-0">{result}</span>
                //       </div>
                //       {/* <div>
                //         <Link   onClick={(e) => {
                //                           e.preventDefault();
                //                           e.stopPropagation();
                //                           setDeleteId(item?.ntfctnId);  // Save ID
                //                           setShow(true);                // Open modal
                //                           toggleDropdown();
                //                         }}> */}
                //       {/* <div className="d-flex align-items-center " > */}
                //       {/* <DeleteOutlineSharpIcon className="material-symbols-sharp me-2 pointer" 

                //                            style={{color:'red !important'}} 
                //                            onClick={(e) => {
                //                           e.preventDefault();
                //                           e.stopPropagation();
                //                           setDeleteId(item?.ntfctnId);  // Save ID
                //                           setShow(true);                // Open modal
                //                           toggleDropdown(); }}/>  */}
                //       {/* </div> */}
                //       {/* </Link>
                //       </div> */}
                //       {item?.typeName === "JobPost" ? (
                //         <div className="customIcon   d-flex justify-content-center align-items-center me-2">

                //           <WorkOutlineSharpIcon className="material-symbols-outlined" />
                //         </div>
                //       ) : item?.typeName === "Message" ? (
                //         <div className="customIcon   messageIcon d-flex justify-content-center align-items-center me-2">
                //           <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                //         </div>
                //       ) : item?.typeName === "Like" ? (
                //         <div className="customIcon   heartCont d-flex justify-content-center align-items-center me-2 heart-icon">
                //           <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                //         </div>
                //       ) : (
                //         ""
                //       )}
                //       <DeleteOutlineSharpIcon className="material-symbols-sharp me-2 pointer delete-iconsymbols"

                //         style={{ color: 'red !important' }}
                //         onClick={(e) => {
                //           e.preventDefault();
                //           e.stopPropagation();
                //           setDeleteId(item?.ntfctnId);  // Save ID
                //           setShowD(true);                // Open modal
                //           toggleDropdown();
                //         }} />

                //     </DropdownItem>

                //   }

                // </li>
                <li className="dropdown-menu-header unreadNotification" key={index}>
                  <DropdownItem
                    to={`/User/${item?.fromUserUid}`}
                    onClick={(e) => {
                      ReadNotification(item?.ntfctnId);
                    }}
                    tag={Link}
                    className="topnotification d-flex align-items-center"
                  >
                    {/* Profile Pic */}
                    <img
                      src={item?.fromProfilPic}
                      width={40}
                      height={40}
                      style={{ borderRadius: "50%" }}
                      className="me-3"
                      alt="Profile Icon"
                    />

                    {/* Text Container */}
                    <div className="notification-text flex-grow-1">
                      {/* Top row → User + Time */}
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="notification-message mb-0">
                          <span>{item?.fromUserFname}</span>
                        </div>
                        <span className="side-text ms-0">{result}</span>
                      </div>

                      {/* Bottom row → Content + Icons */}
                      {/* <div className="d-flex justify-content-between align-items-center">
                        <div className="mb-0 content-text me-2"><span>{item?.content}</span></div>

                        <div className="d-flex align-items-center me-2">
                          {item?.typeName === "JobPost" ? (
                            <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                              <WorkOutlineSharpIcon className="material-symbols-outlined" />
                            </div>
                          ) : item?.typeName === "Message" ? (
                            <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                              <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                            </div>
                          ) : item?.typeName === "Like" ? (
                            <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                              <FavoriteBorderSharpIcon className="material-symbols-outlined" />

                            </div>
                          ) : (
                            ""
                          )}

                          <DeleteOutlineSharpIcon
                            className="material-symbols-sharp pointer delete-iconsymbols d-flex justify-content-center align-items-center me-2"
                            style={{ color: "red" }}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setDeleteId(item?.ntfctnId);
                              setShowD(true);
                              toggleDropdown();
                            }}
                          />
                        </div>
                      </div> */}
                      <div className="d-flex align-items-center justify-content-between">
                        {/* Left → Content */}
                        <div className="mb-0 content-text me-2">
                          <span>{item?.content}</span>
                        </div>

                        {/* Right → Icons + Delete */}
                        <div className="d-flex align-items-center">
                          {item?.typeName === "JobPost" && (
                            <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                              <WorkOutlineSharpIcon className="material-symbols-outlined" />
                            </div>
                          )}
                          {item?.typeName === "Message" && (
                            <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                              <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                            </div>
                          )}
                          {item?.typeName === "Like" && (
                            <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2">
                              <FavoriteBorderSharpIcon className="material-symbols-outlined" />

                            </div>
                          )}
                          <div className="ms-auto d-flex justify-content-center align-items-center me-2">
                            <DeleteOutlineSharpIcon
                              className="material-symbols-sharp pointer delete-iconsymbols"
                              style={{ color: "red" }}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setDeleteId(item?.ntfctnId);
                                setShowD(true);
                                toggleDropdown();
                              }}
                            />

                          </div>

                        </div>
                      </div>

                    </div>
                  </DropdownItem>
                </li>
              ) : item?.type === 17 ||
                item?.type === 19 ||
                item?.type === 20 ||
                item?.type === 21 ||
                item?.type === 22 ||
                item?.type === 23 ||
                item?.type === 25 ||
                item?.type === 26 ? (
                <li
                  className="dropdown-menu-header unreadNotification"
                  key={index}
                >
                  {
                    <DropdownItem
                      onClick={() => {
                        ReadNotification(item?.ntfctnId);
                      }}
                      to={`/JobDetail/${item?.refLinkId}`}
                      tag={Link}
                      className="topnotification d-flex align-items-center"
                    >
                      <img
                        src={item?.fromProfilPic}
                        width={30}
                        height={30}
                        style={{ borderRadius: "50px" }}
                        className="me-3"
                        alt="Profile Icon"
                      />
                      <div className="me-3">
                        <h2 className="notification-message mb-0">
                          <span>{item?.fromUserFname}</span>
                        </h2>
                        <h6 className="mb-0 content-text">
                          <span>{item?.content}</span>
                        </h6>
                        <span className="side-text ms-0">{result}</span>
                      </div>

                      {item?.typeName === "JobPost" ? (
                        <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                          <WorkOutlineSharpIcon className="material-symbols-outlined" />
                        </div>
                      ) : item?.typeName === "Message" ? (
                        <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                          <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                        </div>
                      ) : item?.typeName === "Like" ? (
                        <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2 heart-icon">
                          <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                        </div>
                      ) : (
                        ""
                      )}
                      <DeleteOutlineSharpIcon className="material-symbols-sharp me-2 pointer delete-iconsymbols"

                        style={{ color: 'red !important' }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setDeleteId(item?.ntfctnId);  // Save ID
                          setShowD(true);                // Open modal
                          toggleDropdown();
                        }} />
                    </DropdownItem>
                  }
                </li>
              ) : (
                <li
                  className="dropdown-menu-header unreadNotification"
                  key={index}
                >
                  {
                    <DropdownItem
                      onClick={() => {
                        ReadNotification(item?.ntfctnId);
                      }}
                      to={`/User/${item?.fromUserUid}`}
                      tag={Link}
                      className="topnotification d-flex align-items-center"
                    >
                      <img
                        src={item?.fromProfilPic}
                        width={30}
                        height={30}
                        style={{ borderRadius: "50px" }}
                        className="me-3"
                        alt="Profile Icon"
                      />
                      <div className="me-3">
                        <h2 className="notification-message mb-0">
                          <span>{item?.fromUserFname}</span>
                        </h2>
                        <h6 className="mb-0 content-text">
                          <span>{item?.content}</span>
                        </h6>
                        <span className="side-text ms-0">{result}</span>
                      </div>
                      {item?.typeName === "JobPost" ? (
                        <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                          <WorkOutlineSharpIcon className="material-symbols-outlined" />
                        </div>
                      ) : item?.typeName === "Message" ? (
                        <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                          <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                        </div>
                      ) : item?.typeName === "Like" ? (
                        <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2 heart-icon">
                          <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                        </div>
                      ) : (
                        ""
                      )}
                      <DeleteOutlineSharpIcon className="material-symbols-sharp me-2 pointer delete-iconsymbols"

                        style={{ color: 'red !important' }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setDeleteId(item?.ntfctnId);  // Save ID
                          setShowD(true);                // Open modal
                          toggleDropdown();
                        }} />
                    </DropdownItem>
                  }
                </li>
              )
            ) : item?.type === 3 ||
              item?.type === 12 ||
              item?.type === 13 ||
              item?.type === 14 ||
              item?.type === 15 ||
              item?.type === 16 ? (
              <li className="dropdown-menu-header " key={index}>
                {
                  <DropdownItem
                    to={`/User/${item?.fromUserUid}`}
                    tag={Link}
                    className="topnotification d-flex align-items-center"
                  >
                    <img
                      src={item?.fromProfilPic}
                      width={30}
                      height={30}
                      style={{ borderRadius: "50px" }}
                      className="me-3"
                      alt="Profile Icon"
                    />
                    <div className="me-3">
                      <h2 className="notification-message mb-0">
                        <span>{item?.fromUserFname}</span>
                      </h2>
                      <h6 className="mb-0 content-text">
                        <span>{item?.content}</span>
                      </h6>
                      <span className="side-text ms-0">{result}</span>
                    </div>
                    {item?.typeName === "JobPost" ? (
                      <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                        <WorkOutlineSharpIcon className="material-symbols-outlined" />
                      </div>
                    ) : item?.typeName === "Message" ? (
                      <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                        <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                      </div>
                    ) : item?.typeName === "Like" ? (
                      <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2 heart-icon">
                        <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                      </div>
                    ) : (
                      ""
                    )}
                    <DeleteOutlineSharpIcon className="material-symbols-sharp me-2 pointer delete-iconsymbols"

                      style={{ color: 'red !important' }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setDeleteId(item?.ntfctnId);  // Save ID
                        setShowD(true);                // Open modal
                        toggleDropdown();
                      }} />
                  </DropdownItem>
                }
              </li>
            ) : item?.type === 1 ? (
              <li className="dropdown-menu-header " key={index}>
                {
                  <DropdownItem
                    to={`/Company/${item?.fromUserUid}`}
                    tag={Link}
                    className="topnotification d-flex align-items-center"
                  >
                    <img
                      src={item?.fromProfilPic}
                      width={30}
                      height={30}
                      style={{ borderRadius: "50px" }}
                      className="me-3"
                      alt="Profile Icon"
                    />
                    <div className="me-3">
                      <h2 className="notification-message mb-0">
                        <span>{item?.fromUserFname}</span>
                      </h2>
                      <h6 className="mb-0 content-text">
                        <span>{item?.content}</span>
                      </h6>
                      <span className="side-text ms-0">{result}</span>
                    </div>
                    {item?.typeName === "JobPost" ? (
                      <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                        <WorkOutlineSharpIcon className="material-symbols-outlined" />
                      </div>
                    ) : item?.typeName === "Message" ? (
                      <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                        <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                      </div>
                    ) : item?.typeName === "Like" ? (
                      <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2 heart-icon">
                        <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                      </div>
                    ) : (
                      ""
                    )}
                    <DeleteOutlineSharpIcon className="material-symbols-sharp me-2 pointer delete-iconsymbols"

                      style={{ color: 'red !important' }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setDeleteId(item?.ntfctnId);  // Save ID
                        setShowD(true);                // Open modal
                        toggleDropdown();
                      }} />
                  </DropdownItem>
                }
              </li>
            ) : item?.type === 2 ? (
              <li className="dropdown-menu-header " key={index}>
                {
                  <DropdownItem
                    to={`/Message/${item?.fromUserUid}`}
                    tag={Link}
                    className="topnotification d-flex align-items-center"
                  >
                    <img
                      src={item?.fromProfilPic}
                      width={30}
                      height={30}
                      style={{ borderRadius: "50px" }}
                      className="me-3"
                      alt="Profile Icon"
                    />
                    <div className="me-3">
                      <h2 className="notification-message mb-0">
                        <span>{item?.fromUserFname}</span>
                      </h2>
                      <h6 className="mb-0 content-text">
                        <span>{item?.content}</span>
                      </h6>
                      <span className="side-text ms-0">{result}</span>
                    </div>
                    {item?.typeName === "JobPost" ? (
                      <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                        <WorkOutlineSharpIcon className="material-symbols-outlined" />
                      </div>
                    ) : item?.typeName === "Message" ? (
                      <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                        <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                      </div>
                    ) : item?.typeName === "Like" ? (
                      <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2 heart-icon">
                        <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                      </div>
                    ) : (
                      ""
                    )}
                    <DeleteOutlineSharpIcon className="material-symbols-sharp me-2 pointer delete-iconsymbols"

                      style={{ color: 'red !important' }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setDeleteId(item?.ntfctnId);  // Save ID
                        setShowD(true);                // Open modal
                        toggleDropdown();
                      }} />
                  </DropdownItem>
                }
              </li>
            ) : item?.type === 4 ||
              item?.type === 5 ||
              item?.type === 6 ||
              item?.type === 7 ||
              item?.type === 8 ||
              item?.type === 9 ||
              item?.type === 10 ||
              item?.type === 11 ||
              item?.type === 24 ||
              item?.type === 18 ? (
              <li className="dropdown-menu-header " key={index}>
                {
                  <DropdownItem
                    to={`/Post/${item?.refLinkId}`}
                    tag={Link}
                    className="topnotification d-flex align-items-center"
                  >
                    <img
                      src={item?.fromProfilPic}
                      width={30}
                      height={30}
                      style={{ borderRadius: "50px" }}
                      className="me-3"
                      alt="Profile Icon"
                    />
                    <div className="me-3">
                      <h2 className="notification-message mb-0">
                        <span>{item?.fromUserFname}</span>
                      </h2>
                      <h6 className="mb-0 content-text">
                        <span>{item?.content}</span>
                      </h6>
                      <span className="side-text ms-0">{result}</span>
                    </div>
                    {item?.typeName === "JobPost" ? (
                      <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                        <WorkOutlineSharpIcon className="material-symbols-outlined" />
                      </div>
                    ) : item?.typeName === "Message" ? (
                      <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                        <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                      </div>
                    ) : item?.typeName === "Like" ? (
                      <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2 heart-icon">
                        <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                      </div>
                    ) : (
                      ""
                    )}
                    <DeleteOutlineSharpIcon className="material-symbols-sharp me-2 pointer delete-iconsymbols"

                      style={{ color: 'red !important' }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setDeleteId(item?.ntfctnId);  // Save ID
                        setShowD(true);                // Open modal
                        toggleDropdown();
                      }} />
                  </DropdownItem>
                }
              </li>
            ) : item?.type === 17 ||
              item?.type === 19 ||
              item?.type === 20 ||
              item?.type === 21 ||
              item?.type === 22 ||
              item?.type === 23 ||
              item?.type === 25 ||
              item?.type === 26 ? (
              <li className="dropdown-menu-header " key={index}>
                {
                  <DropdownItem
                    to={`/JobDetail/${item?.refLinkId}`}
                    tag={Link}
                    className="topnotification d-flex align-items-center"
                  >
                    <img
                      src={item?.fromProfilPic}
                      width={30}
                      height={30}
                      style={{ borderRadius: "50px" }}
                      className="me-3"
                      alt="Profile Icon"
                    />
                    <div className="me-3">
                      <h2 className="notification-message mb-0">
                        <span>{item?.fromUserFname}</span>
                      </h2>
                      <h6 className="mb-0 content-text">
                        <span>{item?.content}</span>
                      </h6>
                      <span className="side-text ms-0">{result}</span>
                    </div>
                    {item?.typeName === "JobPost" ? (
                      <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                        <WorkOutlineSharpIcon className="material-symbols-outlined" />
                      </div>
                    ) : item?.typeName === "Message" ? (
                      <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                        <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                      </div>
                    ) : item?.typeName === "Like" ? (
                      <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2 heart-icon">
                        <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                      </div>
                    ) : (
                      ""
                    )}
                    <DeleteOutlineSharpIcon className="material-symbols-sharp me-2 pointer delete-iconsymbols"

                      style={{ color: 'red !important' }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setDeleteId(item?.ntfctnId);  // Save ID
                        setShowD(true);                // Open modal
                        toggleDropdown();
                      }} />
                  </DropdownItem>
                }
              </li>
            ) : (
              <li className="dropdown-menu-header " key={index}>
                {
                  <DropdownItem
                    to={`/User/${item?.fromUserUid}`}
                    tag={Link}
                    className="topnotification d-flex align-items-center"
                  >
                    <img
                      src={item?.fromProfilPic}
                      width={30}
                      height={30}
                      style={{ borderRadius: "50px" }}
                      className="me-3"
                      alt="Profile Icon"
                    />
                    <div className="me-3">
                      <h2 className="notification-message mb-0">
                        <span>{item?.fromUserFname}</span>
                      </h2>
                      <h6 className="mb-0 content-text">
                        <span>{item?.content}</span>
                      </h6>
                      <span className="side-text ms-0">{result}</span>
                    </div>
                    {item?.typeName === "JobPost" ? (
                      <div className="customIcon ms-auto d-flex justify-content-center align-items-center me-2">
                        <WorkOutlineSharpIcon className="material-symbols-outlined" />
                      </div>
                    ) : item?.typeName === "Message" ? (
                      <div className="customIcon ms-auto messageIcon d-flex justify-content-center align-items-center me-2">
                        <ChatBubbleOutlineSharpIcon className="material-symbols-outlined" />
                      </div>
                    ) : item?.typeName === "Like" ? (
                      <div className="customIcon ms-auto heartCont d-flex justify-content-center align-items-center me-2 heart-icon">
                        <FavoriteBorderSharpIcon className="material-symbols-outlined" />
                      </div>
                    ) : (
                      ""
                    )}
                    <DeleteOutlineSharpIcon className="material-symbols-sharp me-2 pointer delete-iconsymbols"

                      style={{ color: 'red !important' }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setDeleteId(item?.ntfctnId);  // Save ID
                        setShowD(true);                // Open modal
                        toggleDropdown();
                      }} />
                  </DropdownItem>
                }
              </li>
            );
          })}

      </div>
    );
  };

  // useEffect(() => {
  //     // notificationList()
  //     // companynotificationList()
  // }, [loadList])

  return (
    <>
      <NotificationsToast
        id={Date.now()}
        show={show}
        data={notificationData}
        onClose={() => setShow(false)}
      />
      <UncontrolledDropdown
        tag=""
        className="dropdown-notification nav-item me-25"
      >
        <DropdownToggle
          tag="a"
          className="nav-link"
          href="/"
          onClick={(e) => e.preventDefault()}
        >

          <NotificationsNoneSharpIcon className="material-symbols-sharp"
            onClick={() => {
              NotificationList();
            }} />
          {displayCount > 0 ? (
            <Badge pill color="danger" className="badge-up notifictaionBadge">
              {displayCount > 99 ? "99+" : displayCount}
            </Badge>
          ) : (
            ""
          )}
        </DropdownToggle>
        <DropdownMenu end tag="ul" className="dropdown-menu-media  mt-0 notificationDropdown"
          style={{ position: 'absolute', zIndex: '9999' }} onMouseEnter={closeTooltip}
          onMouseLeave={closeTooltip}>
          {/* {notifi.length === 0 ? <h4 className="notification-title mb-0 me-auto text-center">No Notification</h4> : */}
          <>
            <li className="dropdown-menu-header">
              <DropdownItem className="d-flex" tag="div" header>
                <h4 className="notification-title mb-0 me-auto">{t("Notifications.Notification")}</h4>
                <div className="badge badge-notificationCount me-3 mb-1">
                  {displayCount} {t("Notifications.New")}
                </div>
              </DropdownItem>
            </li>

            {isLoading ? (
              <ListRowSkeleton count={5} rowHeight={50} showAvatar />
            ) : isError || notifi.length === 0 ? (
              <div className="text-center my-3">
                {/* <img src={emptyMessageImage} alt="No Messages" width={80} /> */}
                <img src={post.errorSmall} alt="Error" width={200} />

                <p className="mt-2">{t("Notifications.No notification found")}</p>
              </div>
            ) : (

              renderNotificationItems()
            )}
            <li className="dropdown-menu-footer">
              <Link  to="/Notification">
                <button
                  type="submit"
                  className="wljPrimaryBtn d-flex align-items-center mt-1 noti-btn"
                >
                  {t("Notifications.View all notifications")}
                </button>
              </Link>
            </li> </>
          {/* } */}
        </DropdownMenu>
      </UncontrolledDropdown>
      {
        unauthorisedModal && (
          <div
            className="modal fade show postAdd"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block" }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content d-flex justify-content-around p-2">
                <div className="d-flex justify-content-between align-items-center p-2">
                  <div>
                    <h4 className="text-center AdBlocker">{t("Recommendations.Warning")}</h4>
                    <p className="text-center ad-p">
                      {t("modals.Your session has expired or you are not authorized to access this resource. Please log in again to continue.")} 
                    </p>
                    <div className="text-center m-auto mt-3">
                      <button
                        type="button"
                        className="mainBtn1 "
                        onClick={() => {
                          setUnauthorisedModal(!unauthorisedModal)
                          navigate("/SignIn");
                          localStorage.clear();
                          sessionStorage.removeItem('hasModalShown');
                        }}
                      >
                        {t("modals.login")} 
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }


      {showD && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("User Profile.Are You Sure You want to Delete?")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleDeleteClose();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={(e) => {
                    deleteNoti(e)
                    e.preventDefault(); // Prevents the default behavior (navigation)
                    e.stopPropagation()
                  }}
                >
                  {t("Drafts.Delete")}
                </button>
              </div>


            </div>
          </div>
        </div>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />

    </>
  );

}
